/**
 * @file       Theme.constant.ts
 * @desc       Stored color-mode keys for Cypher v3 light and dark UI
 * @version    1.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or
 *             altered in anyway without expressed written permission from
 *             MindShare HDV LLC.
 */

const THEME_STORAGE_KEY = 'cypher-theme';
const THEME_CHANGE_EVENT = 'cy-theme-change';

const THEME_MODE =
{
    LIGHT: 'light',
    DARK: 'dark'
} as const;

const THEME_CLASS =
{
    LIGHT: 'cy-theme-light',
    DARK: 'cy-theme-dark'
} as const;

export
{
    THEME_STORAGE_KEY,
    THEME_CHANGE_EVENT,
    THEME_MODE,
    THEME_CLASS
};
